import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/discount";

export default class DiscountService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
